import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { ButtonBase } from '@/components/ui/Button/ButtonBase';
const colors = {
    blue: {
        bg: 'bg-gray-50  hover:bg-turquoise-blue-50 active:bg-turquoise-blue-100',
        border: 'border-turquoise-blue-100',
    },
    navy: {
        bg: 'bg-gray-50 hover:bg-blue-gray-75 active:bg-navy-100',
        border: 'border-navy-100',
    },
    orange: {
        bg: 'bg-gray-50 hover:bg-orange-50 active:bg-orange-100',
        border: 'border-orange-100',
    },
};
const textColors = {
    blue: 'text-link active:text-white',
    navy: 'text-primary active:text-white',
    orange: 'text-secondary active:text-white',
};
export const OutlineButton = (props) => {
    const { children, className = '', color, disabled = false, isFull, onClick, size, textClassName, type, } = props;
    return (_jsx(ButtonBase, Object.assign({ className: clsx(textColors[color], colors[color].bg, colors[color].border, disabled && 'opacity-50', className), disabled: disabled, isFull: isFull, onClick: onClick, size: size, textClassName: textClassName, textColor: 'none', type: type }, { children: children })));
};
export const outlineButtonColors = colors;
export const outlineButtonTextColors = textColors;
